import PropTypes from 'prop-types'

export const metricDataPropType = PropTypes.shape({
  value: PropTypes.number.isRequired,
  target: PropTypes.number.isRequired,
})

export const hourPropType = PropTypes.shape({
  hour: PropTypes.string,
  newLeads: metricDataPropType.isRequired,
  scrapBooked: metricDataPropType.isRequired,
  salvageBooked: metricDataPropType.isRequired,
  talkTime: metricDataPropType.isRequired,
})

export const trackerPropType = PropTypes.shape({
  currentHour: hourPropType,
  historyHours: PropTypes.arrayOf(hourPropType).isRequired,
  overall: PropTypes.number.isRequired,
  stats: PropTypes.shape({
    daily: PropTypes.object,
    hours: PropTypes.arrayOf(hourPropType),
  }),
  timeRemaining: PropTypes.number.isRequired,
})
